// import React from "react";
// import { useState, useEffect } from "react";
// import DefaltImage from '../../../assets/img/logo/jeet.png'

// import {
//   UncontrolledDropdown,
//   DropdownMenu,
//   DropdownItem,
//   DropdownToggle,
// } from "reactstrap";
// import axios from "axios";
// import * as Icon from "react-feather";
// import { Route } from "react-router-dom";
// import axiosConfig from "../../../axiosConfig";

// const handleNavigation = (e, path) => {
//   e.preventDefault();
//   // history.push(path);
//   window.location.replace(path);
// };

// const NavbarUser = () => {
//   const [adminData, setAdminData] = useState({});
//   // console.log(notifications);
// console.log(adminData);

//   const tokenVerify = () => {
//     let data = sessionStorage.getItem("ad-token");

//     if (data === undefined || data === null) {
//       sessionStorage.clear();
//       window.location.replace("/#/pages/login");
//     }
//   };

//   useEffect(() => {
//     tokenVerify();
//     async function getNotifications() {
//       let userId = JSON.parse(sessionStorage.getItem("AyuhAdminPanel"));
//       // console.log("Admin Image URL:", adminData.image);

//       await axiosConfig.get(`/admin/viewById/${userId._id}`).then((res) => {
//         setAdminData(res.data?.admin);
//       })
//         .catch((err) => {
//           console.log(err);
//         });
//     }

//     getNotifications();
//   }, []);

//   return (
//     <ul className="nav navbar-nav navbar-nav-user float-right">
//       <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
//         <DropdownToggle tag="a" className="nav-link dropdown-user-link">
//           <div className="user-nav d-sm-flex d-none">
//             <span className="user-name text-bold-600" color="#fff">
//               {adminData.name}
//             </span>
//             {/* <span className="user-status">Available</span> */}
//           </div>
//           <span data-tour="user">
//             <img
//               src={
//                 adminData.image
//                 ? `https://node.yahuplus.in/Images/${adminData?.image}`
//                 : " " // Default placeholder
//               }
              
//               className="round"
//               height="40"
//               width="40"
//               alt="avatar"
//               />
//           </span>
//         </DropdownToggle>
//         {/* {/ <UserDropdown {...this.props} /> /} */}
//         <DropdownMenu right>
//           <DropdownItem
//             tag="a"
//             href="#"
//             onClick={(e) => handleNavigation(e, "/#/pages/profile")}
//           >
//             <Icon.User size={14} className="mr-50" />
//             <span className="align-middle">Edit Profile</span>
//           </DropdownItem>

//           <DropdownItem divider />
//           <Route
//             render={({ history }) => (
//               <DropdownItem
//                 tag="a"
//                 onClick={(e) => {
//                   localStorage.removeItem("ad-token");
//                   window.location.replace("/#/pages/login");
//                 }}
//               >
//                 <Icon.Power size={14} className="mr-50" />
//                 <span className="align-middle">Log Out</span>
//               </DropdownItem>
//             )}
//           />
//         </DropdownMenu>
//       </UncontrolledDropdown>
//     </ul>
//   );
// };
// export default NavbarUser;
import React from "react";
import { useState, useEffect } from "react";
import DefaltImage from '../../../assets/img/logo/jeet.png'
// constant se baseURLImage import kiya
import { baseURLImage } from "../../../constant";

import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import axios from "axios";
import * as Icon from "react-feather";
import { Route } from "react-router-dom";
import axiosConfig from "../../../axiosConfig";

const handleNavigation = (e, path) => {
  e.preventDefault();
  window.location.replace(path);
};

const NavbarUser = () => {
  const [adminData, setAdminData] = useState({});

  const tokenVerify = () => {
    let data = sessionStorage.getItem("ad-token");

    if (data === undefined || data === null) {
      sessionStorage.clear();
      window.location.replace("/#/pages/login");
    }
  };

  useEffect(() => {
    tokenVerify();
    async function getNotifications() {
      let userId = JSON.parse(sessionStorage.getItem("AyuhAdminPanel"));
      
      if (userId && userId._id) {
        await axiosConfig.get(`/admin/viewById/${userId._id}`).then((res) => {
          setAdminData(res.data?.admin);
        })
        .catch((err) => {
          console.log(err);
        });
      }
    }

    getNotifications();
  }, []);

  return (
    <ul className="nav navbar-nav navbar-nav-user float-right">
      <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
        <DropdownToggle tag="a" className="nav-link dropdown-user-link">
          <div className="user-nav d-sm-flex d-none">
            <span className="user-name text-bold-600" color="#fff">
              {adminData.name || "Admin"}
            </span>
          </div>
          <span data-tour="user">
            <img
              src={
                adminData.image
                ? `${baseURLImage}Images/${adminData.image}`
                : DefaltImage // Agar image na ho toh local logo dikhayega
              }
              className="round"
              height="40"
              width="40"
              alt="avatar"
              onError={(e) => {
                // Agar server se image load hone mein fail ho toh fallback image
                e.target.onerror = null;
                e.target.src = DefaltImage;
              }}
            />
          </span>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem
            tag="a"
            href="#"
            onClick={(e) => handleNavigation(e, "/#/pages/profile")}
          >
            <Icon.User size={14} className="mr-50" />
            <span className="align-middle">Edit Profile</span>
          </DropdownItem>

          <DropdownItem divider />
          <Route
            render={({ history }) => (
              <DropdownItem
                tag="a"
                onClick={(e) => {
                  sessionStorage.removeItem("ad-token");
                  sessionStorage.removeItem("AyuhAdminPanel");
                  window.location.replace("/#/pages/login");
                }}
              >
                <Icon.Power size={14} className="mr-50" />
                <span className="align-middle">Log Out</span>
              </DropdownItem>
            )}
          />
        </DropdownMenu>
      </UncontrolledDropdown>
    </ul>
  );
};
export default NavbarUser;